import get from './get';
import put from './put';

export default { get, put };
